import { deviceSettingsEventType, shipmentEventType, warehouseEventType, projectEventType } from '#type';

const removeFalsy = obj => {
  const newObj = {};
  Object.keys(obj).forEach(key => {
    if (obj[key]) { newObj[key] = obj[key]; }
  });
  return newObj;
};

/**
 * Returns object based on url search params.
 * @param {string} queryString - search query.
 * @returns {Object} Search query state object.
 */

const parseQueryState = queryString => {
  const params = new URLSearchParams(queryString);

  return Object.fromEntries(params.entries());
};

/**
 * Build search params
 * @param {string} params - current search params.
 * @param {Array|Object} newParams - new search params.
 * @returns {string} - merged search params
 */

export const getSearchParams = (params, newParams) => {
  let searchParams;

  if (!newParams) {
    return '';
  }

  if (Array.isArray(newParams)) {
    const parsedCurrUrl = parseQueryState(params);
    searchParams = new URLSearchParams({
      ...parsedCurrUrl,
      ...{ project: '', user: '', device: '', event: '' }
    });
    const param = {
      project: [],
      user: [],
      device: [],
      event: [],
      page: []
    };
    newParams.forEach(el => {
      const { type, value } = el;
      if (searchParams.has(type)) {
        param[type].push(value);
        searchParams.set(type, `${param[type].join(',')}`);
      } else {
        searchParams.set(type, value);
      }
    });
  } else {
    searchParams = new URLSearchParams(params);
    const { filterType, value, end, start } = newParams;

    if (filterType && value) {
      searchParams.set(filterType, value);
    }
    if (start && end) {
      searchParams.set('start', start);
      searchParams.set('end', end);
    }
  }

  const currentUrl = parseQueryState(params);
  const newUrl = parseQueryState(searchParams.toString());
  const mergedUrls = { ...currentUrl, ...newUrl };
  const url = new URLSearchParams(removeFalsy(mergedUrls));

  return `${url.toString()}`;
};

export const getEventDescription = (item, account, isEventTab) => {
  const { actor, device, event: { id }, shipment, appliance, project } = item;
  const isAdminAccess = account?.userType < 10;
  const firstAndLastName = (actor && isAdminAccess) ? `by ${actor.firstName} ${actor.lastName}` : '';
  const wasWord = isEventTab ? '' : ' was ';
  const deviceTitle = isEventTab ? '' : `in ${device.title}`;
  const shipmentLabel = shipment?.label ?? '';
  const applianceLabel = appliance?.label ?? '';
  const projectTitle = project?.title ?? '';

  try {
    switch (id) {
      case deviceSettingsEventType.EDIT_SETTINGS:
        return `Settings ${wasWord} edited ${deviceTitle} ${firstAndLastName}`;
      case shipmentEventType.ADD_DEVICE:
        return `Device ${deviceTitle} ${wasWord} added to the shipment ${shipmentLabel} ${firstAndLastName}`;
      case shipmentEventType.REMOVE_DEVICE:
        return `Device ${deviceTitle} ${wasWord} removed from the shipment ${shipmentLabel} ${firstAndLastName}`;
      case warehouseEventType.ADD_DEVICE:
        return `Device ${deviceTitle} ${wasWord} added to the application ${applianceLabel} ${firstAndLastName}`;
      case warehouseEventType.REMOVE_DEVICE:
        return `Device ${deviceTitle} ${wasWord} removed from the application ${applianceLabel} ${firstAndLastName}`;
      case projectEventType.ADD_DEVICE:
        return `Device ${deviceTitle} ${wasWord} added to the project ${projectTitle} ${firstAndLastName}`;
      case projectEventType.DELETE_DEVICE:
        return `Device ${deviceTitle} ${wasWord} removed from the project ${projectTitle} ${firstAndLastName}`;
      default:
        return 'Not recognized event';
    }
  } catch (e) {
    return 'Not recognized event';
  }
};
